import React from 'react';
import { Hero } from './components/Hero';
import { InitialTestimonials, ExtendedTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { First30Days } from './components/First30Days';
import { MethodOverview } from './components/MethodOverview';
import { Pricing } from './components/Pricing';
import { MidCTA } from './components/MidCTA';
import { Bitacora } from './components/Bitacora';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-gold/30 selection:text-brand-goldLight bg-[#132B1A]" data-id="element-0">
      <Hero data-id="element-1" />
      <InitialTestimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <First30Days data-id="element-4" />
      <MethodOverview data-id="element-5" />
      <MidCTA data-id="element-6" />
      <Bitacora data-id="element-7" />
      <ExtendedTestimonials data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />
      <CostComparison data-id="element-11" />
      <Pricing data-id="element-12" /> {/* Final CTA Section */}
      <Footer data-id="element-13" />
      <FloatingNotification data-id="element-14" />
    </div>;
}